import questionService from '../services/QuestionService';

import { ClozeBehavior } from './ClozeBehavior';

import utilsService from '../services/UtilsService';
import promptService from '../services/PromptService';

export class ClozeMultichoiceBehavior extends ClozeBehavior {
  setResponseData = (data, _responseAnswer, model, { dataId, lessonElementState } = {}) => {
    if (!lessonElementState.currentResponseAnswer.userInputMap) {
      const userInputMap = questionService.updateUserInputMap({
        model, lessonElementState
      });
      userInputMap.set(dataId, {
        ...data.originalData,
        text: (model?.responseFormat === 'html') ?   data.viewLabel : data.label,
      });
    } else {
      lessonElementState.currentResponseAnswer.userInputMap.set(dataId, {
        ...data.originalData,
        text: (model?.responseFormat === 'html') ?   data.viewLabel : data.label,
      });
    }
  }

  isAnswerCorrect = (dataId, lessonElementState, model) => {
    const userInputMap = lessonElementState?.currentResponseAnswer.userInputMap || questionService.updateUserInputMap({
      model,
      responseAnswer: lessonElementState.currentResponseAnswer,
      lessonElementState
    });
    const currentUserInput = userInputMap?.get(dataId);
    
    // For Cloze type questions, check the answerResults array first
    if (lessonElementState?.currentResponseAnswer?.answerResults) {
      const answerResult = lessonElementState.currentResponseAnswer.answerResults.find(result => result.answerId === dataId);
      if (answerResult && answerResult.match !== undefined) {
        return answerResult.match;
      }
    }
    
    // Fallback to existing logic for backward compatibility
    // Stripping paragraph tags here so we can trim the string.
    const currentUserInputValue = currentUserInput?.text;

    const result = currentUserInput?.isCorrect || promptService.isCorrectPromptAnswerStatus({
      dataId, currentUserInputValue, model
    });
    return result;
  }

  setCorrectAnswer = (state, model) => {
    const userInputMap = new Map();
    for (const prompt of model?.validation?.prompts) {
      const correctAnswer = prompt.answers.find((answer) => answer.isCorrect);
      userInputMap.set(prompt.id, {
        dataId: prompt.id,
        text: correctAnswer.text
      });
    }
    state.setCurrentResponse(utilsService.safeMobxClone({
      userInputMap, lessonElementId: model.lessonElementId
    }));
  }

  resetStudentAnswer = (state, _validation) => {
    state.setCurrentResponse(utilsService.safeMobxClone(state.cachedResponseAnswer));
  }
}

export default new ClozeMultichoiceBehavior();
